import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableStatsCard } from '@feathr/components';

import { ConversionTableCardV1 } from './ConversionTableCardV1';

function ConversionTableCard(): JSX.Element {
  const { t } = useTranslation();

  return <TableStatsCard title={t('Conversion Analytics')}>hi</TableStatsCard>;
}

ConversionTableCard.V1 = ConversionTableCardV1;

export default observer(ConversionTableCard);
